// ─────────────────────────────────────────────────────────────────────────────
// PageErrorBoundary — the last line of defence for the Nodes page.
//
// Fetch failures are handled where they happen (useNodesData + nodesService).
// This catches the other half: a RENDER throwing. If the backend ever returns a
// shape nothing expected — a string where an array should be, a null status —
// React unmounts the whole tree on an uncaught error and the user gets a blank
// screen with the real message only in the console.
//
// An error boundary must be a class: there is no hook equivalent of
// componentDidCatch. It contains the damage to this page — the sidebar, topbar
// and routing keep working.
// ─────────────────────────────────────────────────────────────────────────────
import { Component } from "react";
import { ErrorPanel } from "./FetchState";

export default class PageErrorBoundary extends Component {
  state = { failed: false };

  static getDerivedStateFromError() {
    return { failed: true };
  }

  componentDidCatch(error, info) {
    // The real error goes to the console, never to the screen.
    console.error("[Nodes] render failed:", error, info?.componentStack);
  }

  retry = () => {
    this.setState({ failed: false });
    this.props.onRetry?.();
  };

  render() {
    if (!this.state.failed) return this.props.children;
    return (
      <ErrorPanel
        title="This page hit an unexpected error"
        message="The node data couldn't be displayed. Try again — if it keeps happening, the fleet data may be in an unexpected format."
        onRetry={this.retry}
      />
    );
  }
}
